<template>
  <div class="shared-detail">
    <el-row
      class="title"
      type="flex"
      align="middle"
      justify="space-between"
    >
      <h3 class="m-0">
        THÔNG TIN CHI TIẾT {{ data.title.toUpperCase() }} {{ detail.parent_id ? 'CON' : '' }}: {{ detail.name.toUpperCase() }}
      </h3>
      <el-button
        v-if="detail"
        size="small"
        type="primary"
        icon="el-icon-edit"
        @click="$router.push({
          name: `${data.name}Info`,
          params: { id: detail.id }
        })"
      >Chỉnh sửa</el-button>
    </el-row>
    <el-row class="shared-tabs">
      <el-tabs v-model="activeType">
        <el-tab-pane
          v-for="tab in tabs"
          :key="tab.value"
          :label="tab.label.toUpperCase()"
          :name="tab.value"
        />
      </el-tabs>
    </el-row>
    <div v-if="detail.id">
      <shared-index
        v-if="currentRouter.type !== data.type"
        :key="currentRouter.type"
        :type="currentRouter.type"
        :titles="currentRouter.index.titles.filter((t) => !t.children)"
        :columns="currentRouter.index.columns"
        :actions="currentRouter.index.actions"
        :header-actions="currentRouter.index.headerActions"
        :filterable="currentRouter.index.headerActions.includes('filter')"
        :detail="{ ...detail, type: data.type }"
        :tab="currentRouter"
      />
      <shared-index
        v-if="currentTabType && currentTabType.children"
        :key="`${currentRouter.type}-children`"
        :type="currentRouter.type"
        :titles="currentRouter.index.titles.filter((t) => !t.children)"
        :columns="currentRouter.index.columns"
        :actions="currentRouter.index.actions"
        :header-actions="currentRouter.index.headerActions"
        :filterable="currentRouter.index.headerActions.includes('filter')"
        :detail="{ ...detail, type: data.type }"
        :children="true"
        :tab="currentRouter"
      />
    </div>
  </div>
</template>

<script>
import { getAccountRouters } from '@/utils/filters'
import SharedIndex from './index'

export default {
  name: 'SharedDetail',
  components: {
    SharedIndex
  },
  props: {
    data: Object,
    detail: Object,
    tabs: Array
  },
  data() {
    return {
      activeType: this.tabs[0].value
    }
  },
  computed: {
    currentTabType() {
      return this.tabs.find((r) => r.value === this.activeType)
    },
    currentRouter() {
      return getAccountRouters().find((r) => r.type === this.activeType)
    }
  }
}
</script>

<style lang="scss" scoped>
.shared-detail {
  .title {
    padding: 15px;
    background-color: #2b314a;
    color: white;
  }
  .shared-tabs {
    padding: 0 15px 15px 15px;
    background-color: #2b314a;
    color: white;
  }
}
</style>
<style lang="scss">
.shared-detail {
  .shared-tabs {
    .el-tabs__item {
      color: white;
      &:hover {
        color: #409eff;
      }
      &.is-active {
        color: #409eff;
      }
    }
  }
}
</style>
